import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { NAV_PARAM_PATHS } from '../../navigation/paths.ts'
import { numericIdParam } from '../params.ts'
import { rootRoute } from '../root.tsx'

// The scheda the players list links a name to.

const personIdParam = numericIdParam('personId')

export const officialPlayerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PARAM_PATHS.officialPlayer,
  params: personIdParam,
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/player.tsx')),
})

/** One tesserato as a link target: `params` typed, so no page respells the path. */
export function officialPlayerLink(personId: number) {
  return { to: '/me/official/players/$personId', params: { personId } } as const
}
